import { isEmpty, isString, isEqual } from 'underscore';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import Log from 'forms-utils-lib/logger/Logger';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Form... Remove this comment to see the full error message
import LegalConsent from 'FormsCommonComponents/lib/LegalConsent';
import { LegalConsentKeys } from 'FormsCommonComponents/constants/LegalConsent';
import { DEFAULT_LANG } from 'FormsCommonComponents/constants/Languages';
const ONE_TO_ONE = 'ONE_TO_ONE';
const i18nKey = suffix => `formsLegalText.communicationCheckbox.${suffix}`;
function hydrateCommunicationCheckboxesWithDefaultId(checkboxes, id) {
  // Add default id to first checkbox without communicationTypeId
  return checkboxes.map((checkbox, index) => {
    if (index === 0 && !checkbox.communicationTypeId) {
      return {
        label: checkbox.label,
        communicationTypeId: id,
        required: false
      };
    }
    return checkbox;
  }).filter(({
    communicationTypeId
  }) => communicationTypeId); // Filter out checkboxes with null or 0 as id
}
export function generateSubscriptionTypeSelectOptions(options = []) {
  return options.map(({
    category,
    channel,
    id,
    name
  }) => {
    return {
      value: id,
      text: name,
      help: I18n.text(i18nKey('selectHelpText'), {
        category,
        channel
      })
    };
  });
}
export function stripHtmlTags(label) {
  return label.replace(/<[^>]*>/g, '');
}
export function buildDefaultLegalOptions(lang, consentCopy) {
  try {
    if (!consentCopy) return null;
    const parsedLang = isEmpty(lang) ? getLang() : lang;
    const currentLangCopy = consentCopy[parsedLang] || consentCopy[DEFAULT_LANG];
    const formattedLangCopy = Object.keys(currentLangCopy).reduce((accum, key) => {
      const value = currentLangCopy[key];
      if (!isString(value)) {
        return Object.assign({}, accum, {
          [key]: value
        });
      }
      const formattedValue = isEqual(stripHtmlTags(value), value) ? `<p>${value}</p>` : value;
      return Object.assign({}, accum, {
        [key]: formattedValue
      });
    }, {});
    return Object.assign({}, formattedLangCopy, {
      [LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES]: JSON.parse(currentLangCopy[LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES])
    });
  } catch (error) {
    Log.error('Error Parsing default Legal Consent options', {
      error
    });
    return {};
  }
}
export function getDefaultSubscriptionId(subscriptionDefinitions) {
  const activeSubscriptions = subscriptionDefinitions.filter(i => i.active === true);
  const oneToOneSubscription = activeSubscriptions.find(i => i.internalName === ONE_TO_ONE);
  const {
    id
  } = oneToOneSubscription || activeSubscriptions[0] || {};
  return id;
}
export const buildCheckboxOption = (subscriptionId, domain, language) => {
  const labelKey = 'SharedLegalStrings.consent.communicationConsentCheckboxes.label';
  const localeOption = language ? {
    locale: language
  } : {};
  return {
    communicationTypeId: subscriptionId,
    label: I18n.text(labelKey, Object.assign({
      companyName: domain
    }, localeOption))
  };
};
export function buildLegalConsent({
  option,
  defaultTexts,
  communicationConsentCheckboxes,
  subscriptionDefinitions,
  domain
}) {
  const subscriptionId = getDefaultSubscriptionId(subscriptionDefinitions);
  const checkbox = buildCheckboxOption(subscriptionId, domain);
  const checkboxOptions = isEmpty(communicationConsentCheckboxes) ? [checkbox] : hydrateCommunicationCheckboxesWithDefaultId(communicationConsentCheckboxes, subscriptionId);
  const legalConsent = LegalConsent.createLegalConsentFromOption(option, Object.assign({
    checkboxOptions,
    domain
  }, defaultTexts));
  return legalConsent;
}